import repository from "@/plugins/axios/secureClient";

const resource = "/qr-gifts";

export default {
  getList(params) {
    return repository.get(`${resource}/`, { params });
  },
  getOne(id) {
    return repository.get(`${resource}/${id}`);
  },
  update(id, payload) {
    return repository.put(`${resource}/${id}`, payload);
  },
  tagsMassUpdate(payload) {
    return repository.put(`${resource}/mass-update-tags`, payload);
  },
  namesMassUpdate(payload) {
    return repository.put(`${resource}/mass-update-names`, payload);
  }
};
